import {
	INPUT_ESTIMATE_NAME,
	INPUT_ESTIMATE_EMAIL,
	INPUT_ESTIMATE_PHONE,
	INPUT_ESTIMATE_DATE_EVENT,
	INPUT_ESTIMATE_TYPE_EVENT,
	INPUT_ESTIMATE_MSG,
	SEND_ESTIMATE,
	SET_ESTIMATE_STATUS
} from './Types';

export const inputName = txt => { return { type: INPUT_ESTIMATE_NAME, payload: txt } };
export const inputEmail = txt => { return { type: INPUT_ESTIMATE_EMAIL, payload: txt } };
export const inputPhone = txt => { return { type: INPUT_ESTIMATE_PHONE, payload: txt } };
export const inputDateEvent = txt => { return { type: INPUT_ESTIMATE_DATE_EVENT, payload: txt } };
export const inputTypeEvent = txt => { return { type: INPUT_ESTIMATE_TYPE_EVENT, payload: txt } };
export const inputMsg = txt => { return { type: INPUT_ESTIMATE_MSG, payload: txt } };
export const sendEstimate = () => { return { type: SEND_ESTIMATE } };
export const setEstimateStatus = txt => { return { type: SET_ESTIMATE_STATUS, payload: txt } };


// WEBPACK FOOTER //
// ./src/actions/EstimateActions.js